import ServiceFormFields from "./ServiceFormFields";
import { IconClose } from "./ServiceCardIcons";

function EditServicePopup({
  service,
  mileage,
  onMileageChange,
  dateISO,
  onDateChange,
  cost,
  onCostChange,
  mechanic,
  onMechanicChange,
  description,
  onDescriptionChange,
  pending,
  error,
  onCancel,
  onSave,
}) {
  if (!service) return null;

  return (
    <div className="ls-pop-overlay" onClick={onCancel} role="dialog" aria-modal="true" aria-label="ویرایش سرویس">
      <div className="ls-pop" dir="rtl" onClick={(e) => e.stopPropagation()}>
        <div className="ls-pop__header">
          <span className="ls-pop__title">ویرایش سرویس</span>
          <button type="button" className="ls-pop__close" onClick={onCancel} aria-label="بستن">
            <IconClose />
          </button>
        </div>
        <div className="ls-pop__subtitle">{service.displayType}</div>

        <div className="ls-pop__body">
          <ServiceFormFields
            mileage={mileage}
            onMileageChange={onMileageChange}
            dateISO={dateISO}
            onDateChange={onDateChange}
            cost={cost}
            onCostChange={onCostChange}
            mechanic={mechanic}
            onMechanicChange={onMechanicChange}
            description={description}
            onDescriptionChange={onDescriptionChange}
            disabled={pending}
          />
          {error && <div className="ls-pop__error">{error}</div>}
        </div>

        <div className="ls-pop__actions">
          <button
            type="button"
            className="completed-card__btn completed-card__btn--save"
            disabled={pending}
            onClick={onSave}
          >
            {pending ? "در حال ذخیره..." : "ذخیره"}
          </button>
          <button
            type="button"
            className="completed-card__btn completed-card__btn--cancel"
            disabled={pending}
            onClick={onCancel}
          >
            انصراف
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditServicePopup;
